/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Signedin1Inputs */

const he_verify_signedin1 = /** @type {(inputs: Verify_Signedin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברת בהצלחה. מעביר...`)
};

const en_verify_signedin1 = /** @type {(inputs: Verify_Signedin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have been signed in. Redirecting...`)
};

/**
* | output |
* | --- |
* | "You have been signed in. Redirecting..." |
*
* @param {Verify_Signedin1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const verify_signedin1 = /** @type {((inputs?: Verify_Signedin1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Signedin1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_signedin1(inputs)
	return en_verify_signedin1(inputs)
});
export { verify_signedin1 as "verify_signedIn" }